import { selectEventCount } from '@store/commonSlice';
import { useAppSelector } from '@store/index';
import { setCookie } from '@utils/common';
import { MAX_COOKIE_KEY, MIN_COOKIE_KEY } from '@utils/constants';
import { useEffect, useState, type ChangeEvent } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

const Level = ({
    activeMin,
    activeMax,
    toggleAsideMenu,
}: {
    activeMin: string | null;
    activeMax: string | null;
    toggleAsideMenu: (show: boolean) => void;
}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [min, setMin] = useState('');
    const [max, setMax] = useState('');
    const { t } = useTranslation();

    const saveAndCloseEvent = useAppSelector(selectEventCount);

    const handleConfirm = () => {
        if (parseInt(min, 10) > parseInt(max, 10)) {
            toastFn(t('I006'));
            return false;
        }
        searchParams.set('min', min || '1');
        searchParams.set('max', max);
        setSearchParams(searchParams);
        setCookie(MIN_COOKIE_KEY, min);
        setCookie(MAX_COOKIE_KEY, max);
        toggleAsideMenu(false);

        return false;
    };

    useEffect(() => {
        if (saveAndCloseEvent > 0) handleConfirm();
    }, [saveAndCloseEvent]);

    useEffect(() => {
        setMin(activeMin ?? '');
        setMax(activeMax ?? '');
    }, [activeMin, activeMax]);

    return (
        <div className="block border border-solid border-gray010 mb-[15px] mx-[20px] lg:mb-[11px] lg:mx-0">
            <legend className="hide-text">Level</legend>
            <label className="text-base text-black068 block leading-[21px] bg-gray004 pt-[10px] pb-[13px] pl-[16px]">{t('I002')}</label>
            <div className="flex justify-between items-center pt-[18px] px-[16px] pb-[20px]">
                <input
                    className="w-[47%] h-[38px] text-base !text-black045 leading-[21px] indent-2 border border-gray010 bg-bg rounded-[4px] lg:w-[36%]"
                    type="text"
                    inputMode="numeric"
                    value={min}
                    style={{ color: 'black' }}
                    onChange={(event) => handleNumberChange(event, setMin)}
                    placeholder="1"
                    pattern="[0-9]*"
                />
                <span className="text-base text-black045">~</span>
                <input
                    className="w-[47%] h-[38px] text-base !text-black045 leading-[21px] indent-2 border border-gray010 bg-bg rounded-[4px] lg:w-[36%]"
                    type="text"
                    inputMode="numeric"
                    value={max}
                    style={{ color: 'black' }}
                    onChange={(event) => handleNumberChange(event, setMax)}
                    placeholder="Max"
                    pattern="[0-9]*"
                />
                <button
                    onClick={handleConfirm}
                    className="hidden relative lg:inline-block w-[38px] h-[38px] bg-point rounded-[4px] before:content-[''] before:inline-block before:w-[10px] before:h-[13.865px] before:bg-arrow before:absolute before:left-[50%] before:top-[50%] before:transform before:translate-x-[-50%] before:translate-y-[-50%]"
                ></button>
            </div>
        </div>
    );
};
export default Level;

const handleNumberChange = (e: ChangeEvent<HTMLInputElement>, setNumber: (value: string) => void) => {
    let val = e.target.value.replace(/[^0-9]/g, '');
    val = val.length > 4 ? val.substring(0, 4) : val;
    setNumber(val);
};

const toastFn = (msg: string) => {
    toast(
        (t) => (
            <div className="toast-wrapper">
                <span className="toast-title">{msg}</span>
            </div>
        ),
        {
            duration: 3000,
            className: 'common-toast',
            position: 'bottom-center',
        }
    );
};
